<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style>
@import url("@/assets/style.css");
@import url("../node_modules/emoji-data-css/files/tw-all-emoji.css");
</style>
